import { Box, styled } from "@mui/material";
import { colors } from "../../theme/colors";

// Status type to color mapping
const getStatusColors = (status: string): { bg: string; text: string } => {
  switch (status) {
    // Treatment plan statuses
    case "in-progress":
      return { bg: "#FFFBE6", text: "#BE8522" };
    case "approved":
      return { bg: "#E8F5E9", text: "#2E7D32" };
    case "declined-by-patient":
      return { bg: colors.background.red, text: colors.text.error };

    // User statuses
    case "active":
      return { bg: colors.status.activeBg, text: colors.status.activeText };
    case "inactive":
      return { bg: "#F5F5F5", text: colors.text.secondary };
    case "invited":
      return { bg: colors.status.invitedBg, text: colors.status.invitedText };
    case "suspended":
      return {
        bg: colors.status.suspendedBg,
        text: colors.status.suspendedText,
      };

    // Tenant statuses
    case "pending-activation":
      return { bg: "#FFFBE6", text: "#BE8522" };
    case "deleted":
      return { bg: "#F5F5F5", text: "#9E9E9E" };

    // Action statuses (audit logs)
    case "success":
      return { bg: "#DCFCE7", text: "#166534" };
    case "failure":
      return { bg: "#FEE2E2", text: "#991B1B" };

    // Default
    default:
      return { bg: "#F5F5F5", text: colors.text.secondary };
  }
};

export const Badge = styled(Box)<{ status: string; width?: string | number }>(({
  status,
  width,
}) => {
  const statusColors = getStatusColors(status);
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 12px",
    borderRadius: "6px",
    fontSize: "14px",
    height: "24px",
    fontWeight: 700,
    fontFamily: "Nunito",
    backgroundColor: statusColors.bg,
    color: statusColors.text,
    width: width || "auto",
    whiteSpace: "nowrap",
  };
});
